<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} nền tảng dịch vụ</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} nền tảng dịch vụ</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} nền tảng dịch vụ</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="9">
              <b-row>
                <b-col md="4">
                  <el-form-item label="Tên nền tảng" prop="ten">
                    <el-input v-model="mData.dataForm.ten" :disabled="mData.viewMode == 'detail'" clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Dịch vụ" prop="dich_vu">
                    <el-select v-model="mData.dataForm.dich_vu" :default-first-option="true"
                      :disabled="mData.viewMode == 'detail'" clearable filterable>
                      <el-option v-for="item in mData.dataDefault.listServiceType" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Trạng thái hiển thị" prop="hien_thi">
                    <el-select v-model="mData.dataForm.hien_thi" :default-first-option="true"
                      :disabled="mData.viewMode == 'detail'" clearable filterable>
                      <el-option v-for="item in mData.dataDefault.listVisible" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3">
              <el-form-item class="mb-3" label="Ảnh nền tảng" prop="image_id">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda v-if="mData.viewMode == 'create'">{{
              aLang.c_create
            }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="mData.viewMode == 'update'">{{
              aLang.c_update
            }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import DataService from '@/service/DataService';
import NenTangDichVuApi from '@/moduleApi/NenTangDichVuApi';
import NenTangDichVuModel from '@/views/admin/NenTangDichVu/NenTangDichVuModel';
import ExtensionService from "../../../service/ExtensionService";
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      aRole: MethodService.checkRole,
      mData: {
        viewMode: "create",
        moduleName: "NenTangDichVu",
        dataDefault: {
          listVisible: DataService.visibleList,
          listServiceType: DataService.serviceTypeList
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        dataForm: MethodService.copyObject(NenTangDichVuModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          NenTangDichVuModel.dataFormOther.fileUploadOption
        ),
        validForm: NenTangDichVuModel.validForm,
      },
    };
  },
  async mounted() { },
  async created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create"
    ) {
      this.mData.viewMode = "create";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
      if (this.$router.currentRoute.params.id) {
        this.fn_getDataById(this.$router.currentRoute.params.id);
      }
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            await NenTangDichVuApi.create(data);
            this.fn_go();
            this.fn_resetForm();
          }
          if (type === "update") {
            await NenTangDichVuApi.update(data);
            this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        NenTangDichVuModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      const nenTangDichVuRes = await NenTangDichVuApi.findById(id);
      if (nenTangDichVuRes.result) {
        let resData = await this.fn_changeData(nenTangDichVuRes.result);
        this.mData.dataForm = resData;
        if (nenTangDichVuRes.result.image_id) {
          let data = {
            id: nenTangDichVuRes.result.image_id,
            name: nenTangDichVuRes.result.image_id,
            url: ExtensionService.urlImg + nenTangDichVuRes.result.image_id
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
      }
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.image_id = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("image_id");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "NenTangDichVu")
        .then(res => {
          this.mData.dataForm.image_id = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("image_id");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("image_id");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;

    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  }
}
</script>
